<template>
  <div class="d-flex m-3 gap-2">

    <!-- Main Content -->
    <div class="w-80 d-flex flex-column">
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4>Tab</h4>
        <p class="text-gray-600 mb-2">Use tabs to change content while staying on the same page.</p>
        
        <h5 class="mt-4 mb-2">How to Import</h5>
        <p class="text-gray-600">To install the DTTButton component, install its package from bit.dev</p>
        <code class="bg-gray-100 p-3 mt-2 mb-3">yarn add @bit/dtt.uic.dt-tabs</code>
        <p class="text-gray-600">To use the DTTButton component in your Vue component.</p>
        <code class="bg-gray-100 p-3 mt-2">import DtTabs from '@bit/dtt.uic.dt-tabs'</code>
        
      </div>

      <TabsOverview />

      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-4 mt-2">Props</h4>
        <b-table striped bordered :items="items" :fields="fields"></b-table>

        <h6 class="mb-4 mt-4">Include the following objects in the array for <strong class="text-danger">tabList</strong> to display specific info</h6>
        <b-table striped bordered :items="arrays" :fields="fieldsArray"></b-table>       
      </div>
    </div>

    <!-- Quick Links -->
    <!-- <div class="w-20">
      <a
        v-for="(item, index) in components" :key="index"
        href="javascript:void(0)"
        class="decoration-none"
        @click="$router.push(`${item.link}`)"
      >{{ item.name }}</a>
    </div> -->
  </div>
</template>

<script>
import TabsOverview from '@/components/local/Tabs/TabsOverview'

export default {
  components: { TabsOverview },
  data () {
    return {
      components: [
        { name: 'Buttons', link: 'buttons' },
        { name: 'Inputs', link: 'inputs' },
        { name: 'Tabs', link: 'tabs' },
      ],

      fields: [
        { key: 'prop', tdClass: 'setAmountTdClass' },
        { key: 'type', tdClass: 'setAmountTdClass' },
        { key: 'description' }
      ],

      fieldsArray: [
        { key: 'object', tdClass: 'setAmountTdClass' },
        { key: 'type', tdClass: 'setAmountTdClass' },
        { key: 'description' }
      ],

      items: [
          { prop: 'tabList', type: 'Array', description: 'Contains the list of tab options' },
      ],

      arrays: [
          { object: 'text', type: 'String', description: 'Text content of the tab' },
          { object: 'count', type: 'String', description: 'Contains count data' },
          { object: 'icon', type: 'String', description: 'CSS class of a Font Awesome icon' },
      ]
    }
  },

  methods: {
    setAmountTdClass() {
        return 'code-text'
    }
  }
}
</script>

<style>
.code-text {
  font-family: "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono" ,"Courier New", monospace;
  color: red!important;
}
</style>